import { useQuery } from '@tanstack/react-query'
import { useNavigate, useSearch } from '@tanstack/react-router'

import { getNotificationHistoryQuery } from '@/lib/queries/notification/v1/history/queries'
import { NotificationType } from '@/lib/queries/notification/v1/history/types'
import { cn } from '@/lib/utils'

import { NOTIFICATIONS_PER_PAGE } from '../../constants'
import { UpdatesLoading } from '../updates-loading'
import { CaseUpdateList } from './case-update-list'
import { CaseUpdateListPagination } from './case-update-list-pagination'

export const CaseUpdates = () => {
  const navigate = useNavigate()

  const { page: currentPage } = useSearch({
    from: '/_dashboard/updates',
  })

  const { data: dataNotifications, isLoading } = useQuery(
    getNotificationHistoryQuery({
      pageNumber: currentPage,
      pageSize: NOTIFICATIONS_PER_PAGE,
      notificationType: NotificationType.CASE_UPDATES,
    })
  )

  const handleChangePage = (page: number) => {
    void navigate({ search: { page } })
  }

  if (isLoading) {
    return <UpdatesLoading />
  }

  return (
    <div className={cn('space-y-6')}>
      <CaseUpdateList notifications={dataNotifications?.result ?? []} />
      <CaseUpdateListPagination
        currentPage={currentPage}
        totalCounts={dataNotifications?.totalCount ?? 0}
        onChangePage={handleChangePage}
      />
    </div>
  )
}
